(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-brands"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gg-brand-marquee')) {
    customElements.define('gg-brand-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._viewport = this.querySelector('[data-marquee-viewport]');
        this._track = this.querySelector('[data-marquee-track]');
        this._groups = Array.from(this.querySelectorAll('.gg-marquee-group'));
        if (!this._viewport || !this._track || !this._groups[0]?.children.length) return;
        this._ready = true;
        this._events = new AbortController();
        const options = {signal: this._events.signal};
        this._motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._userPaused = this._motionPreference.matches;
        this._userChoice = false;
        this._pressed = false;
        this._focusPaused = false;
        this._visible = true;
        this.dataset.enhanced = 'true';
        this._viewport.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          this._pressed = true;
          this._sync();
        }, options);
        const release = () => { this._pressed = false; this._sync(); };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        window.addEventListener('blur', release, options);
        this.addEventListener('keydown', event => {
          if (event.target !== this || ![' ', 'Enter'].includes(event.key)) return;
          event.preventDefault();
          this._userChoice = true;
          this._userPaused = !this._userPaused;
          this._sync();
        }, options);
        this.addEventListener('focusin', event => {
          const link = event.target.closest('[data-brand-link]');
          if (link && link.matches(':focus-visible')) {
            this._focusPaused = true;
            this._sync();
            this._reveal(link);
          }
        }, options);
        this.addEventListener('focusout', () => queueMicrotask(() => {
          if (!this.isConnected) return;
          this._focusPaused = this.contains(document.activeElement) && document.activeElement.matches('[data-brand-link]:focus-visible');
          this._sync();
        }), options);
        document.addEventListener('visibilitychange', () => this._sync(), options);
        this._motionPreference.addEventListener('change', () => {
          if (!this._userChoice) this._userPaused = this._motionPreference.matches;
          this._sync();
        }, options);
        this._resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this._resizeFrame);
          this._resizeFrame = requestAnimationFrame(() => this._build());
        });
        this._resizeObserver.observe(this._viewport);
        this._intersectionObserver = new IntersectionObserver(entries => {
          this._visible = entries[0].isIntersecting;
          this._sync();
        });
        this._intersectionObserver.observe(this);
        this._build();
      }
      _build() {
        if (!this.isConnected) return;
        const phase = this._animation && this._duration ? (Number(this._animation.currentTime || 0) % this._duration) / this._duration : 0;
        this._groups.forEach(group => { group.style.minWidth = `${this._viewport.clientWidth}px`; });
        this._distance = this._groups[0].getBoundingClientRect().width;
        if (!this._distance) return;
        this._speed = Math.max(15, Number(this.dataset.speed) || 35);
        this._duration = this._distance / this._speed * 1000;
        this._animation?.cancel();
        this._animation = this._track.animate([{transform: 'translate3d(0,0,0)'}, {transform: `translate3d(-${this._distance}px,0,0)`}], {duration: this._duration, iterations: Infinity, easing: 'linear'});
        this._animation.currentTime = phase * this._duration;
        this._sync();
      }
      _sync() {
        if (!this._ready) return;
        const paused = this._userPaused || this._pressed || this._focusPaused || !this._visible || document.hidden;
        this.dataset.paused = String(paused);
        this.dataset.userPaused = String(this._userPaused);
        const staticMotion = this._motionPreference.matches && this._userPaused;
        this.dataset.reducedMotion = String(staticMotion);
        if (staticMotion) {
          this._animation?.cancel();
          this._animation = null;
        } else if (!this._animation) {
          this._build();
          return;
        } else {
          paused ? this._animation.pause() : this._animation.play();
        }
      }
      _reveal(link) {
        if (!this._animation) return;
        const offset = Math.min(Math.max(link.offsetLeft - (this._viewport.clientWidth - link.offsetWidth) / 2, 0), Math.max(this._distance - this._viewport.clientWidth, 0));
        this._animation.currentTime = offset / this._speed * 1000;
      }
      disconnectedCallback() {
        this._events?.abort();
        this._resizeObserver?.disconnect();
        this._intersectionObserver?.disconnect();
        cancelAnimationFrame(this._resizeFrame);
        this._animation?.cancel();
        this._ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
